const ConvenienceSubContentListBox = () => {
	return (
		<ul>
			{/* 대시보드 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">매출/매입 정보</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									로그인 후 메인 메뉴에서 확인할 수 있으며, 월별 매출매입 및 매출 이익 현황이 조회됩니다.
								</li>
								<li className="bullet">
									세금계산서, 신용카드, 현금영수증 등 증빙별 매출매입 현황 및 외상 매출매입 거래처 Top5를 파악할 수
									있습니다.
								</li>
								<li className="bullet">
									매일 업데이트되는 챠트 및 시각데이터를 통해 편리하게 자금 흐름을 파악하고, 경영관리를 위한 인사이트를
									제공받을 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">계좌현황</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									[금융관리]-[계좌현황] 메뉴에서 확인할 수 있으며, [기초정보]-[외부기관연동]에서 연동 수집된 계좌의 잔액
									및 예적금/대출/펀드/외화 등 계좌별 현황을 한 눈에 파악할 수 있습니다.
								</li>
								<li className="bullet">
									계좌 현황에서도 즉시 계좌 연동이 가능하며, 수집된 자료 기준 계좌의 연동 개수, 현 잔액과 총액 대비
									비율의 정보 등 자산 대비 비율을 제공합니다.
								</li>
								<li className="bullet">
									계좌의 형태에 따라 입출금 잔액 현황(상세), 예적금 계좌 현황, 대출 계좌 현황, 외화 잔액 현황 등의 상세
									데이터를 조회해 주며, 대출계좌의 경우 원금과 이율 등을 표기하고, 외화 계좌의 경우 통화 코드별 외화
									잔액과 원화로 환산된 금액을 표기하여 자금 관리에 매우 유효한 정보를 제공합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">입출금계좌</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									[금융관리]-[입출금계좌] 메뉴에서 확인할 수 있으며, [기초정보]-[외부기관연동]에서 연동한 모든 계좌의
									목록과 잔액이 조회됩니다.
								</li>
								<li className="bullet">
									전월대비 입/출금 통계 및 계좌 입출금 현황, 월간 입출금 Top5 거래처 등을 한 눈에 확인할 수 있어서 계좌
									흐름을 쉽게 파악할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">카드 정보</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									[금융관리]-[카드] 메뉴에서 확인할 수 있으며, [기초정보]-[외부기관연동]에서 연동한 모든 카드사의 자료를
									기준으로 조회됩니다.
								</li>
								<li className="bullet">
									월 누적 금액 일별 카드 사용현황, 월 청구금액 및 카드 사용추이 등을 한 눈에 확인할 수 있어서 카드
									사용내역을 쉽게 파악할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">기타 대시보드</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									금융관리, 인사/급여, 재고관리 메뉴에서도 각 개별 대시보드를 시각화된 데이터로 제공합니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 신용정보 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">나이스 평가정보 제휴(업계 최초! 국내 유일!)</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">40년 이력의 국내 최대 개인 및 기업 신용정보 데이터베이스 보유</li>
								<li className="bullet">기업 개요, 재무∙비재무 정보, 대안정보, 각종 신용등급 및 평가 데이터 제공</li>
								<li className="bullet">
									업계 최초! 국내유일! 오직 스텔라 고객만을 위한 자사 및 거래처 신용정보 관리 기능 제공
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">기본 신용 정보 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">거래처 신용등급을 22단계 구간으로 나누어 제공합니다.</li>
								<li className="bullet">
									AAA+ ~ D 등급까지의 신용등급 제공을 통해 거래처의 안정성에 대한 평가가 가능합니다.
								</li>
								<li className="bullet">
									상세매출, 자산, 부채, 자본, 세전이익, 부채비율, 세전이익률 등 최신 주요 재무정보를 제공합니다.
								</li>
								<li className="bullet">
									최근 신용등급 변동일자, 변동 단계를 제공해드리며 조회된 거래처 일반개요 정보를 스텔라 거래처정보로
									업데이트 할 수 있습니다.
								</li>
								<li className="bullet">
									[기초정보]-[정보관리]-[거래처정보] 메뉴에서 거래처 신용등급에 대한 정보를 확인하실 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 프로젝트 관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">프로젝트/현장정보 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									프로젝트와 현장은 탭으로 구분되어 등록 가능하며, 각 프로젝트 또는 현장별로 거래를 입력하여 해당 건 별
									총 매출액과 사용된 비용 등을 따로 산출해 볼 수 있습니다.
								</li>
								<li className="bullet">
									신규등록과 수정, 삭제가 가능하며 등록된 프로젝트 및 현장 리스트를 다운로드하여 관리할 수 있습니다.
								</li>
								<li className="bullet">
									수집된 거래내역에 부서, 사원정보 뿐 아니라 프로젝트 및 현장 정보를 입력하여 전표 연동 발행 가능
								</li>
								<li className="bullet">
									[회계관리]-[경영보고서]에서 프로젝트별/현장별 손익보고서를 바로 확인 가능하며, 수익과 비용을
									세부적으로 분석하는 데 활용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 기업뱅킹 연동 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">금융사 직접 연동</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									금융사별 기업인터넷뱅킹 가입 후 가입은행에서 사용한 공인인증서 연동 후 스텔라 플랫폼 연동하면
									이체기능을 바로 사용할 수 있습니다.
								</li>
								<li className="bullet">
									금융사별 제공하는 이체건수보다 스텔라플랫폼을 이용하면 더 많은 이체가 가능하도록 혜택을 드립니다.
								</li>
								<li className="bullet">
									주 이용 금융사 직접연동으로 더욱 빠르고 간편하게 각종 이체서비스를 이용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 원천세 신고 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">원천세 신고</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									원천세는 모든 원천징수 소득(근로/사업/기타/퇴직)에 대해 부과되는 소득세(국세)와 지방소득세(지방세)를
									의미하며, 해당 소득자의 원천세를 사업자가 지급액에서 먼저 제한 후 국가에 대신 납부하는 제도를
									말합니다.
								</li>
								<li className="bullet">
									급여를 지급하는 근로자가 있는 기업은 급여 지급일이 속하는 달의 다음달 10일까지 원천세신고 및 납부를
									해야 합니다.
								</li>
								<li className="bullet">
									[세금신고]-[원천세신고] 메뉴에서 이용할 수 있으며, 귀속년월과 지급년월 기준 급여자료에 등록된 각
									소득구분별로 자료가 자동으로 반영되므로 원천세신고 자료인 원천징수이행상황신고서와 간이지급명세서를
									간편하게 작성할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 부가세 신고 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">부가세 신고서 생성</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">매입매출전표 증빙유형 및 계정과목에 기반하여 부가세 신고서를 생성합니다.</li>
								<li className="bullet">
									예정/확정 신고, 영세율 조기환급, 기한 후 신고 등 다양한 신고 기능을 제공합니다.
								</li>
								<li className="bullet">
									사용자가 직접 작성해야 할 첨부서류는 작성 서식을 제공하여 편리하게 작업이 가능합니다.
								</li>
								<li className="bullet">작성내용 저장, 신고서 마감 기능을 통해 자료변환을 방지합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">주요서류 지원 목록</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">부가가치세신고서(일반과세자 신고서 및 수정신고서)</li>
								<li className="bullet">사업장현황명세서, 부가가치세 납부서</li>
								<li className="bullet">
									매출세금계산서합계표, 매입세금계산서합계표, 매출계산서합계표, 매입계산서합계표, 신용카드매출전표등
									수령명세서, 신용카드매출전표발행금액집계표
								</li>
								<li className="bullet">
									공제받지못할 매입세액명세서, 건물등감가상각자산취득명세서,대손세액공제(변제)신고서 전자세금계산서
									발급세액공제신고서, 과표수정 및 추가납부계산서, 과표 및 세액경정청구서
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">업종별 첨부 서류 지원 목록</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매입자발행세금계산서합계표, 매입자발행계산서합계표, 부동산임대공급가액명세서, 의제매입세액공제신고서,
									재활용폐자원세액공제신고서, 현금매출명세서, 전자화폐결제명세서, 수출실적명세서,
									영세율첨부서류제출명세서, 영세율매출명세서, 내국신용장/구매확인서, 외화획득명세서
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 세금 계산서 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">세금계산서 발행</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									일반/영세/면세 등 모든 과세 유형별 세금계산서를 발행할 수 있습니다. 발행한 세금계산서는 즉시발송 혹은
									익일 전송으로 선택이 가능하며, 익일 전송으로 발행된 세금계산서는 전송 전(발행당일)에 한하여 발행취소가
									가능합니다.
								</li>
								<li className="bullet">
									전자 발행한 세금계산서가 홈택스로 전송 완료되면 [홈택스 전송 후]탭에서 조회되며, 즉시전송으로 발행 한
									세금계산서는 즉시 홈택스로 전송되어 발행 취소는 불가 하며, 전송 완료 처리 후 수정 발행만 가능 합니다.
								</li>
								<li className="bullet">이메일로 자동발행되며 발행 내역의 출력이 가능합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">거래명세서 발행</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									거래명세서 발행 시에는 [기초정보]에서 등록한 [품목정보] 를 불러오기 할 수 있으며, 항목을 직접 추가 및
									삭제가 가능하며, 작성한 거래명세서로 세금계산서 발행도 가능합니다.
								</li>
								<li className="bullet">이메일/문자/팩스로 전자발행되며 출력이 가능합니다.</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 보고서 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">경영보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">경영보고서 및 금융보고서는 [회계관리] 메뉴에서 확인 가능합니다.</li>
								<li className="bullet">
									미수금 및 미지급금 현황에 대해 거래처별 별로 확인할 수 있으며 기간 설정 시 해당기간의 잔액을 자동
									계산하여 제공하고 있습니다.
								</li>
								<li className="bullet">
									기간별 영업이익, 매출액 및 매입액을 파악할수 있도록 기간손익보고서를 제공하고 있습니다.
								</li>
								<li className="bullet">
									프로젝트별, 현장별, 부서별 손익보고서도 자동으로 생성되며, 다운로드 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">금융보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">입력된 전표 기준으로 전일잔액과 당일 증감에 대한 현황을 확인할 수 있습니다.</li>
								<li className="bullet">
									자금일보를 통해 현금 등의 자금 흐름을 정확하게 파악함으로써 금융위험을 효과적으로 관리할 수 있으며,
									투명성을 강화하고 회계 감사 시 필요한 정보를 제공합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">급여보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">급여보고서는 [인사/급여] 메뉴에서 확인 가능합니다.</li>
								<li className="bullet">
									연간 급여집계 및 지급 항목별 집계, 공제항목별 집계 등 사원별 세부적인 급여관리가 가능합니다.
								</li>
								<li className="bullet">
									지급 항목은 급여업무설정에 등록되어 있는 항목을 기준으로 급여가 등록된 이력이 있는 항목에 대해
									사원별로 지급된 금액을 세부적으로 확인할 수 있습니다.
								</li>
								<li className="bullet">
									공제 항목은 급여업무설정에 등록되어 있는 항목을 기준으로 공제된 내역에 대해 확인할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 기간비용 & 기간수익 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list cost">
					<div className="function-text">
						<strong className="title">기간비용</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									사업을 하다 보면 보험료, 임대료, 공사비처럼 한 번에 결제하지만, 실제로는 여러 달에 걸쳐 사용되는
									비용들이 있습니다. <br />
									이런 비용은 회계상 한 번에 전액 비용처리하지 않고, 기간에 맞게 나눠 인식해야 합니다. <br />
									이를 ‘선급비용의 상각’이라고 하며 스텔라의 ‘기간비용’ 기능은 이 과정을 정확하고 편리하게 도와드립니다.
									<p className="bullet-title">예시)</p>
									<ul className="bullet-dot">
										<li className="bullet">보험료를 연 단위로 결제했지만, 매달 일정액만 비용으로 처리하고 싶은 경우</li>
										<li className="bullet">임대료를 선불로 지급했지만, 사용 기간에 맞춰 비용 인식이 필요한 경우</li>
										<li className="bullet">
											공사비, 유지보수비 등 장기 계약에 따른 선급비용을 분할하여 처리하고 싶은 경우
										</li>
									</ul>
									<ul className="bullet-num">
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>① 자동 상각표 제공</span>
												</p>
												→ 선급비용을 기간에 따라 나누어 매달 얼마씩 비용으로 인식해야 할지 미리 확인할 수 있습니다.
											</div>
										</li>
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>② 정확한 전표 자동 생성</span>
												</p>
												→ 상각 일정에 맞춰 매달 전표를 자동으로 생성해, 누락 없이 회계처리할 수 있습니다.
											</div>
										</li>
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>③ 다양한 항목에 적용 가능</span>
												</p>
												→ 보험료뿐만 아니라, 임대료·공사비 등 모든 선급비용 항목에 적용할 수 있습니다.
											</div>
										</li>
									</ul>
									정확한 회계처리로 세무 리스크를 줄이고, 복잡한 비용 인식도 간편하게 해결하세요. ‘기간비용’ 기능으로 더
									스마트한 회계 관리, 지금 바로 경험해보세요
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">기간수익</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									서비스 요금을 한 번에 청구하거나 수령했더라도, 실제 제공 기간에 맞춰 수익을 나눠서 인식해야 하는
									경우가 있습니다. 이럴 때 필요한 것이 바로 ‘기간수익’ 기능입니다.
									<br />
									회계상 이를 선수수익의 인식이라고 하며, 스텔라는 이 복잡한 과정을 자동 계산 + 전표 처리로 간편하게
									해결해드립니다.
									<p className="bullet-title">예시)</p>
									<ul className="bullet-dot">
										<li className="bullet">
											연간 이용권이나 SaaS 요금을 미리 청구했지만, 매달 서비스 제공에 따라 수익을 나눠 인식해야 하는
											경우
										</li>
										<li className="bullet">
											프로젝트 계약금을 먼저 받았지만, 실제로는 진행 기간에 따라 수익을 분할 인식해야 하는 경우
										</li>
										<li className="bullet">
											임대료 등 선불로 받은 수익을 계약 기간에 맞춰 수익으로 인식해야 하는 경우
										</li>
										<li className="bullet">
											장기 유지보수/서비스 계약 등, 계약 기간 중 지속적으로 제공하는 서비스의 수익 인식
										</li>
									</ul>
									<ul className="bullet-num">
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>① 수익 분할 계산 자동화</span>
												</p>
												→ 설정한 제공 기간에 따라 매월 인식해야 할 수익 금액을 자동 계산합니다.
											</div>
										</li>
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>② 정확한 수익 전표 자동 생성</span>
												</p>
												→ 매달 인식해야 할 금액만큼 자동으로 전표를 생성하여, 회계 누락 없이 관리할 수 있어요.
											</div>
										</li>
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>③ SaaS, 임대, 프로젝트 등 다양한 업종에 적용 가능</span>
												</p>
												→ 반복 수익, 고정 수익, 계약 기반 수익 등 어떤 형태의 매출에도 유연하게 대응합니다.
											</div>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 반제관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list community">
					<div className="function-text">
						<strong className="title">
							통장 입∙출금 내역과 연계한 <br />
							반제전표 생성
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">실제 입출금 내역과 연결하여, 손쉽게 반제 전표를 생성할 수 있습니다.</li>
								<li className="bullet">
									전표 생성 시 거래처별 반제 잔액을 확인하고, 반제할 거래를 선택해 처리할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">
							다양한 반제 방식 지원 <br />
							(전액, 부분, 초과 반제)
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">전액반제, 부분반제, 초과반제를 모두 지원합니다.</li>
								<li className="bullet">반제처리 시 자동분개가 기본 제공되어 수작업 부담을 줄여줍니다.</li>
								<li className="bullet">반제를 원하지 않는 기준전표는 반제 제외 설정도 가능합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">과거 거래건 반제 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									올해 거래뿐만 아니라 과거 발생한 미반제 건도 리스트로 확인하고 관리할 수 있습니다.
								</li>
								<li className="bullet">남아있는 잔액을 놓치지 않고 체계적으로 관리하세요.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">반제 현황 페이지 제공</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">거래처별∙계정과목별 기준전표와 반제전표를 한눈에 볼 수 있습니다.</li>
								<li className="bullet">반제전표를 직접 입력하여 추가 반제도 간편하게 처리할 수 있습니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">
							AR(매출채권) 만기일 관리 및 <br />
							채권연령 보고서 제공
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">채권 발생일 및 만기일을 기준으로 채권연령을 분석할 수 있습니다.</li>
								<li className="bullet">
									만기일 기준 또는 거래일자 기준으로 남은 채권을 상세히 파악할 수 있어, 보다 정확한 회수계획 수립이
									가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">AP(매입채무) 잔액 채권연령별 분석</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매입채무에 대해서도 거래처별 잔액을 채권연령별로 구분하여 확인할 수 있습니다.
								</li>
								<li className="bullet">지급계획 수립과 현금흐름 관리를 더욱 체계적으로 지원합니다.</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 세무대리인 소통함 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list community">
					<div className="function-text">
						<strong className="title">소통함</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									스텔라/파로스 내에서 세무대리인과 간편하게 질문을 주고받고, 요청 내용을 한눈에 확인할 수 있습니다.
								</li>
								<li className="bullet">
									하나의 요청에 대해 지속적으로 댓글을 통해 세무대리인과 내용을 주고받으며 세부 사항을 명확히 할 수
									있습니다.
								</li>
								<li className="bullet">
									각종 세무 자료나 필요한 서류를 간편하게 주고받을 수 있어 업무 효율이 향상됩니다.
								</li>
								<li className="bullet">
									새로운 문의나 답변이 등록되면 즉시 카카오톡으로 알림을 받아 빠르게 확인할 수 있습니다.
								</li>
							</ul>
							<ul className="bullet-star">
								<li className="bullet">단, 세무대리인이 COMPAS 서비스를 사용하는 경우에만 이용할 수 있습니다.</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
		</ul>
	);
};

export default ConvenienceSubContentListBox;
